// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import laborRate from './labor-rate';
import modal from './modal';
import selectedDealers from './dealers-selected';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    laborRate,
    modal,
    selectedDealers
});



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/reducers/index.js